module.exports = __webpack_public_path__ + "static/media/attach-pdf.0f07a30a.svg";